var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
/* eslint-disable react/no-unescaped-entities */
/* eslint-disable jsx-quotes */
/* eslint-disable quotes */
/* eslint-disable max-len */
/* eslint-disable react/jsx-one-expression-per-line */
import React, { useEffect, useRef } from "react";
import { useSelector } from "react-redux";
import Link from "../../common/components/Link/Link";
import useAppDispatch from "../../common/hooks/useAppDispatch";
import useIntersectionObserver from "../../common/hooks/useIntersectionObserver";
import useVisiblePage from "../../common/hooks/useVisiblePage";
import { Page } from "../../common/reducers/visible-page/visible-page-types";
import { initializeYoutubeData } from "../../common/reducers/youtube/youtube-reducer";
import selectYoutube from "../../common/reducers/youtube/youtube-selectors";
import URL from "../../common/types/url-types";
import Title from "../../components/Title/Title";
import YoutubeInfo from "../../components/YoutubeInfo/YoutubeInfo";
var YouTube = function () {
    var ref = useRef(null);
    var animationRef = useRef(null);
    useVisiblePage(ref, Page.YOUTUBE);
    var animationEntry = useIntersectionObserver(animationRef, {
        freezeOnceVisible: true,
    });
    var dispatch = useAppDispatch();
    var youtubeData = useSelector(selectYoutube());
    useEffect(function () {
        dispatch(initializeYoutubeData());
    }, []);
    return (React.createElement("div", { ref: ref, className: "youtube" },
        React.createElement("div", { className: "youtube__description-container" },
            React.createElement(Title, { title: "What's Next?" }),
            React.createElement("p", { className: "youtube__description" },
                "I am currently seeking a ",
                React.createElement("b", null, "Full-time role"),
                " in software engineering where I can hopefully ",
                React.createElement("b", null, "learn"),
                " new stuff and get to practice what I already know."),
            React.createElement("p", { className: "youtube__description" }, "If this website caught your eye, here's my resume \u2192")),
        React.createElement("div", { ref: animationRef, className: "youtube__billboard-container", "data-animate": animationEntry === null || animationEntry === void 0 ? void 0 : animationEntry.isIntersecting },
            React.createElement("div", { className: "youtube__billboard youtube__billboard-right" },
                React.createElement("div", { className: "youtube__billboard-content" },
                    React.createElement(Link, { href: URL.YOUTUBE }, "My Resume"))),
            youtubeData.loaded && (React.createElement("div", { className: "youtube__billboard youtube__billboard-left" },
                React.createElement("div", { className: "youtube__billboard-content" },
                    React.createElement(YoutubeInfo, __assign({}, youtubeData))))))));
};
export default YouTube;
